export enum MUTATIONS_ORDER {
    SET_ORDER = 'SetOrder',
    SET_SHIPPING_ADDRESS = 'SetShippingAddress',
    SET_SHIPPING_CONTACT_DATA = 'SetShippingContactData',
    SET_SHIPPING = 'SetShipping',
    SET_PAYMENT_METHOD = 'SetPaymentMethod',
}

export enum MUTATIONS_TOASTS {
    ADD_TOAST = 'AddToast',
    REMOVE_TOAST = 'RemoveToast',
}
